import axios from 'axios';
import Swal from 'sweetalert2';
import { fetchAllPositions } from './fetchAllPositions';

export function deletePosition(positionId) {
  return (dispatch) => {
    return axios
      .delete(`/position/${positionId}`)
      .then((response) => {
        const { status } = response.data;
        if (status === 'SUCCESS') {
          Swal.fire({
            title: 'Success',
            text: 'Successfully deleted a position',
            icon: 'success',
            confirmButtonColor: '#3f51b5',
          });
          dispatch(fetchAllPositions());
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
